import StageBlockType from "../../../Types/StageBlockType";

const StageBlock = ({ img,text, description }: StageBlockType) => {
  return (
    <div className="stage">
      <img className="stageImage" src={img} alt=""></img>
      <h3>{text}</h3>
      <div className="stageDescription">
        <label>{description}</label>
      </div>
    </div>
  );
};

export default StageBlock;
